import {SubUserModel} from '../subuser.model';

export class SubUsersResponseModel {
  users: SubUserModel[];

  constructor(obj:any) {
    this.users = obj.map((dt: any) => dt as SubUserModel);
  }
}
